<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h600_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              需求信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <!-- <el-col :span="6">
                  <el-form-item label="需求类型">
                    <el-input
                      v-model="dialogAddEditForm.typeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="市场">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="需求方"
                    prop="demandSide"
                  >
                    <el-input v-model="dialogAddEditForm.demandSide" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="需求来源"
                    prop="schemeContent"
                  >
                    <el-input
                      v-model="dialogAddEditForm.schemeContent"
                      type="textarea"
                      placeholder="请输入需求来源"
                      autosize
                      maxlength="1000"
                      class="source-textarea"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="收货库房"
                    prop="receiveDepotId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.receiveDepotId"
                      filterable
                      clearable
                      placeholder="请选择库房"
                      style="width:100%"
                      @change="receiveDepotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货人">
                    <el-input
                      v-model="dialogAddEditForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货联系电话">
                    <el-input
                      v-model="dialogAddEditForm.receivePhone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货地址">
                    <el-input
                      v-model="dialogAddEditForm.receiveAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              申请信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="需求物料"
                    prop="materialsId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.materialsId"
                      filterable
                      clearable
                      placeholder="请选择需求物料"
                      style="width:100%"
                      @change="materialsChangeFun"
                    >
                      <el-option
                        v-for="item in materialsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.typeValue }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="物料单位">
                    <el-input
                      v-model="dialogAddEditForm.materialsUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="申请制作数量"
                    prop="applyMakeNumber"
                  >
                    <el-input
                      v-model="dialogAddEditForm.applyMakeNumber"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditForm, 'applyMakeNumber')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditForm, 'applyMakeNumber', 2)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 物料API
import { listMaterialsApi } from '@/api/v2/materials';
// 数据请求
import { initMaterialsDemandApi, saveMaterialsDemandApi } from '@/api/materialsDemandDetail'
import { depotListSelectDataApi } from '@/api/depot';

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data () {
    // 申请制作数量
    const validateApplyMakeNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入申请制作数量'))
      } else if (Number(value) === 0) {
        callback(new Error('申请制作数量必须大于0'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        receiveDepotId: [{ required: true, message: '请选择物料收货库房', trigger: 'change' }],
        materialsId: [{ required: true, message: '请选择需求物料', trigger: 'change' }],
        applyMakeNumber: [{ required: true, validator: validateApplyMakeNumber, trigger: 'blur' }],
        schemeContent: [{ required: true, message: '请输入需求来源', trigger: 'blur' }, { max: 100, message: '需求来源最多输入100个字符', trigger: 'blur' }],
        demandSide: [{ required: true, message: '请输入需求方', trigger: 'blur' }, { max: 32, message: '需求方最多输入32个字符', trigger: 'blur' }],
        remark: [{ max: 255, message: '备注最多输入255个字符', trigger: 'blur' }]
      },
      materialsOptions: [],
      depotOptions: []

    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })

        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.materialsOptions = []
        this.depotOptions = []
        this.dialogAddEditForm = {
          type: 2,
          typeValue: '',
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          schemeContent: '',
          demandSide: '',
          isExecute: 0,
          demandSort: 0, // 需求方式
          executeMethod: 0, // 需求执行方式
          materialsId: '',
          materialsName: '',
          materialsUnitId: 0,
          materialsUnitName: '',
          materialsSpecification: '',
          applyMakeNumber: 0,
          receiveDepotId: '', // 制作物料收货库房ID
          receiveDepotName: '', // 制作物料收货库房名称
          receiverId: 0, // 制作物料收货人ID
          receiver: '', // 制作物料收货人姓名
          receivePhone: '', // 制作物料收货联系电话
          receiveAddress: '', // 制作物料收货地址
          remark: '',
        }

        // 获取收货库房选项数据
        this.initDepotSelectData()
        // 获取物料下拉选择项
        this.initMaterialsData()
        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData () {
      initMaterialsDemandApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditForm) {
          if (key.endsWith('Date')) this.dialogAddEditForm[key] = data[key + 'Value']
          else this.dialogAddEditForm[key] = data[key]
        }

        this.dialogAddEditForm.id = data.id
        this.loading = false
      })
    },
    // 初始市场本地仓库下拉数据
    initDepotSelectData () {
      depotListSelectDataApi({ status: "1", isFixedAsset: "2", filterUserCity: "true", notManage: "true" }).then(res => {
        res.data.forEach(item => {
          this.depotOptions.push({
            label: item.name,
            value: item.id,
            provinceId: item.provinceId || 0,
            provinceName: item.provinceName || '',
            cityId: item.cityId || 0,
            cityName: item.cityName || '',
            receiverId: item.receiverId || 0,
            receiverName: item.receiverName || '',
            receivePhone: item.phone || '',
            receiveAddress: item.receiveAddress || ''
          })
        })
      })
    },
    // 选择库房回调
    receiveDepotChangeFun (val) {
      let selectItem = {}
      selectItem = this.depotOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.receiveDepotName = selectItem ? selectItem.label : ''
      this.dialogAddEditForm.receiverId = selectItem ? selectItem.receiverId : 0
      this.dialogAddEditForm.receiver = selectItem ? selectItem.receiverName : ''
      this.dialogAddEditForm.receivePhone = selectItem ? selectItem.receivePhone : ''
      this.dialogAddEditForm.receiveAddress = selectItem ? selectItem.receiveAddress : ''
      this.dialogAddEditForm.provinceId = selectItem ? selectItem.provinceId : 0
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.provinceName : ''
      this.dialogAddEditForm.cityId = selectItem ? selectItem.cityId : 0
      this.dialogAddEditForm.cityName = selectItem ? selectItem.cityName : ''
    },
    // 获取物料下拉框数据
    initMaterialsData () {
      listMaterialsApi({ sortIds: '1, 2, 5', orderSort: 'sort_id, brand_id asc' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.materialsOptions.push({
            label: item.name, value: item.id, sortId: item.sortId, unitName: item.minimumUnit, unitId: 0, specification: item.specification, typeValue: item.sortName + ' - ' + item.brandName
          })
        })
      })
    },
    // 选择物料回调
    materialsChangeFun (val) {
      let selectedItem = {}
      selectedItem = this.materialsOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.materialsName = selectedItem.label || ''
      this.dialogAddEditForm.materialsUnitId = selectedItem.unitId || 0
      this.dialogAddEditForm.materialsUnitName = selectedItem.unitName || ''
      this.dialogAddEditForm.materialsSpecification = selectedItem.specification || ''
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定修改物料需求申请', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.operateButtonDisable = true
            this.loading = true
            this.loadingText = '正在处理数据中，请耐心等待'

            this.dialogAddEditForm.applyTotal = Number(this.mathApplyTotal)
            saveMaterialsDemandApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.source-textarea {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
    font-size: 12px;
  }
}
</style>
